<mat-select
  [tabIndex]="tabIndex"
  [formControl]="selectCtrl"
  [compareWith]="compareWith"
  (selectionChange)="onSelectionChange()">
  <mat-option *ngFor="let template of activityPdfTemplates" [value]="template">{{template.name}}</mat-option>
</mat-select>

<mat-progress-spinner *ngIf="loading === true" diameter="16" mode="indeterminate"></mat-progress-spinner>
